import { parseDocument } from 'htmlparser2';
import { processNodes } from './processNodes.js';
export function convertHtmlToReact(html, options) {
    const parsedDocument = parseDocument(html, {
        decodeEntities: options?.decodeEntities ?? true
    });
    const processedDocument = options?.preprocessNodes?.(parsedDocument) ?? parsedDocument;
    return processNodes(processedDocument.childNodes, options?.transform);
}
//# sourceMappingURL=convertHtmlToReact.js.map